import React from 'react';
import { Link } from 'react-router-dom';
import { Image, Button, Container, Text, Box } from '@chakra-ui/react';
import preval from 'preval.macro';
import Footer from '../components/Footer';

function Canterano() {
  const isDemo = process.env.REACT_APP_IS_DEMO === 'true';
  const isPromo = process.env.REACT_APP_IS_PROMO === 'true';
  const currentYear = new Date().getFullYear();
  const imgUrl = `/images/${process.env.REACT_APP_PROJECT_ID}`;

  return (
    <Container my={50} bg='#3c4d5f' centerContent>
      {isDemo && (
        <Text color={'gold'} fontSize={'xl'} fontWeight={600}>
          DEMO
        </Text>
      )}
      <Text my={5} color={'white'} fontSize={'5xl'} fontWeight={600} textAlign='center'>
        CANTERANO {currentYear}
      </Text>

      <Image src={`${imgUrl}/logo.png`} alt='Sagra del tartufo' />
      <Text my={10} color={'white'} fontSize={'xl'}>
        Benvenuti alla <b>Sagra del Tartufo di Canterano</b>, edizione {currentYear}!
        <br />
        <br />
        Evita la fila alla cassa e ordina le nostre delizie in tutta comodità con il tuo smartphone:
        puoi scegliere i <b>menù completi</b> oppure acquistare i <b>singoli piatti</b>.
      </Text>

      {/* MENU BUTTON */}
      <Button
        borderRadius={'15px'}
        as={Link}
        to='menu'
        mt={37}
        mb={10}
        w={'90%'}
        maxW={'400px'}
        h={'60px'}
        size={'lg'}
        fontSize={'30px'}
      >
        Vai al menù
      </Button>

      {/* SUPPORT BUTTON */}
      <Button
        borderRadius={'15px'}
        as={Link}
        to='support'
        mt={37}
        w={'90%'}
        maxW={'400px'}
        h={'60px'}
        size={'lg'}
        fontSize={'22px'}
      >
        Hai smarrito il tuo ordine?
      </Button>

      {/* PROMO BUTTON */}
      {isPromo && (
        <Button
          as={Link}
          to='promo'
          borderRadius={'15px'}
          mt={30}
          w={'90%'}
          maxW={'400px'}
          h={'60px'}
          size={'lg'}
          fontSize={'22px'}
          textAlign={'center'}
        >
          Segnala un evento <br/> vinci un premio!
        </Button>
      )}

      <Box mt={10}>
        <Footer />
        <Text textAlign='center' fontSize={8} mt={2}>
          {preval`module.exports = new Date().toLocaleString();`}
        </Text>
      </Box>
    </Container>
  );
}

export default Canterano;
